<!-- @Author Shyam @Date 26/03/2026 @Description:Task workflow step Component -->
<div class="col-12 mt-4">
  <h4 class="section-title">Task Options</h4>

  <form
    *ngIf="taskStepForm"
    [formGroup]="taskStepForm"
    class="task-step-container"
  >
    <div class="row g-3 px-2 px-md-4">
      <!-- Task Label -->
      <div class="col-12 col-sm-6 col-lg-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Task Label</mat-label>
          <input matInput formControlName="taskLabel" />
        </mat-form-field>
      </div>

      <!-- Assign To -->
      <div class="col-12 col-sm-6 col-lg-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Assign Task To</mat-label>
          <mat-select formControlName="assignTo">
            <mat-option *ngFor="let p of participants" [value]="p">
              {{ p }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Instructions -->
      <div class="col-12 col-sm-6 col-lg-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Instructions</mat-label>
          <input matInput formControlName="instructions" />
        </mat-form-field>
      </div>

      <!-- Due Date Type -->
      <div class="col-12 col-sm-6 col-lg-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Due Date Based On</mat-label>
          <mat-select formControlName="dueDateType">
            <mat-option value="TASK_CREATED">Task Creation Date</mat-option>
            <mat-option value="WORKFLOW_START">Workflow Start Date</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Offset Days -->
      <div class="col-12 col-sm-6 col-lg-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Offset Days</mat-label>
          <input matInput type="number" formControlName="offsetDays" />
        </mat-form-field>
      </div>

      <!-- Email Template -->
      <div class="col-12 col-sm-6 col-lg-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Email Template</mat-label>
          <mat-select formControlName="notificationTemplate">
            <mat-option *ngFor="let t of templates" [value]="t">
              {{ t }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Enable Verdicts -->
      <!-- <div class="col-12 col-sm-6 col-lg-4 d-flex align-items-center">
      <mat-checkbox formControlName="enableVerdicts">
        Prompt for Verdicts
      </mat-checkbox>
    </div> -->

      <!-- PROMPTS SECTION -->
      <div class="col-12 mt-4">
        <h4 class="section-title">Prompts</h4>
      </div>

      <!-- ============================= -->
      <!-- PROMPT FOR COMMENTS -->
      <!-- ============================= -->

      <!-- PROMPT FOR COMMENTS -->

      <!-- PROMPT FOR COMMENTS -->

      <div class="col-12 mt-3 veeva-section">
        <div class="veeva-header">
          <mat-checkbox formControlName="promptComments">
            Prompt for Comments
          </mat-checkbox>
        </div>

        <div *ngIf="taskStepForm && taskStepForm.get('promptComments')?.value">
          <table class="veeva-table">
            <thead>
              <tr>
                <th>Comment Label</th>
                <th class="required-column">Required</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <input class="veeva-input" formControlName="commentLabel" />
                </td>

                <td class="required-column">
                  <mat-checkbox
                    formControlName="commentRequired"
                  ></mat-checkbox>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ============================= -->
      <!-- PROMPT FOR FIELDS -->
      <!-- ============================= -->

      <!-- PROMPT FOR FIELDS -->

      <!-- ============================= -->
      <!-- PROMPT FOR FIELDS -->
      <!-- ============================= -->

      <div class="col-12 mt-3 veeva-section">
        <div class="veeva-header">
          <mat-checkbox formControlName="promptFields">
            Prompt for Fields
          </mat-checkbox>
        </div>

        <div *ngIf="taskStepForm.get('promptFields')?.value">
          <table class="veeva-table">
            <thead>
              <tr>
                <th>Fields</th>
                <th class="required-column">Required</th>
                <th class="action-column"></th>
              </tr>
            </thead>

            <tbody
              *ngIf="fields && fields.controls.length > 0"
              formArrayName="fields"
            >
              <tr
                *ngFor="let field of fields.controls; let i = index"
                [formGroupName]="i"
              >
                <td>
                  <select class="veeva-input" formControlName="fieldName">
                    <option *ngFor="let f of availableFields" [value]="f">
                      {{ f }}
                    </option>
                  </select>
                </td>

                <td class="required-column">
                  <mat-checkbox formControlName="required"></mat-checkbox>
                </td>

                <td class="action-column">
                  <mat-icon class="remove-icon" (click)="removeField(i)">
                    close
                  </mat-icon>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="add-field">
            <mat-icon (click)="addField()">add_circle</mat-icon>
            Add field
          </div>
        </div>
      </div>

      <!-- ============================= -->
      <!-- PROMPT FOR PARTICIPANTS -->
      <!-- ============================= -->

      <div class="col-12 mt-3 veeva-section">
        <div class="veeva-header">
          <mat-checkbox formControlName="promptParticipants">
            Prompt for Workflow Participants
          </mat-checkbox>
        </div>

        <div *ngIf="taskStepForm.get('promptParticipants')?.value">
          <table class="veeva-table">
            <thead>
              <tr>
                <th>Participants</th>
                <th class="action-column"></th>
              </tr>
            </thead>

            <tbody
              *ngIf="participantsArray && participantsArray.controls.length > 0"
              formArrayName="participantsArray"
            >
              <tr
                *ngFor="let p of participantsArray.controls; let i = index"
                [formGroupName]="i"
              >
                <td>
                  <select class="veeva-input" formControlName="participant">
                    <option *ngFor="let p of participants" [value]="p">
                      {{ p }}
                    </option>
                  </select>
                </td>

                <td class="action-column">
                  <mat-icon class="remove-icon" (click)="removeParticipant(i)">
                    close
                  </mat-icon>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="add-field">
            <mat-icon (click)="addParticipant()">add_circle</mat-icon>
            Add Participant
          </div>
        </div>
      </div>

      <!-- ============================= -->
      <!-- PROMPT FOR VERDICTS -->
      <!-- ============================= -->

      <div class="col-12 mt-3 veeva-section">
        <div class="veeva-header">
          <mat-checkbox formControlName="enableVerdicts">
            Prompt for Verdicts
          </mat-checkbox>
        </div>

        <div *ngIf="taskStepForm.get('enableVerdicts')?.value">
          <table class="veeva-table">
            <thead>
              <tr>
                <th>Verdict Label</th>
                <th class="action-column"></th>
              </tr>
            </thead>

            <tbody
              *ngIf="verdicts && verdicts.controls.length > 0"
              formArrayName="verdicts"
            >
              <tr
                *ngFor="let v of verdicts.controls; let i = index"
                [formGroupName]="i"
              >
                <td>
                  <input class="veeva-input" formControlName="label" />
                </td>

                <td class="action-column">
                  <mat-icon class="remove-icon" (click)="removeVerdict(i)">
                    close
                  </mat-icon>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="add-field">
            <mat-icon (click)="addVerdict()">add_circle</mat-icon>
            Add Verdict
          </div>
        </div>
      </div>

      <!-- ============================= -->
      <!-- SHORT CIRCUIT OPTIONS -->
      <!-- ============================= -->

      <!-- <div class="col-12 mt-4">
      <p class="fw-semibold">Short-circuit tasks with the configured tags.</p>

      <div class="d-flex flex-wrap gap-3">
        <mat-checkbox formControlName="addComments">
          Add Comments
        </mat-checkbox>

        <mat-checkbox formControlName="addCapacities">
          Add Capacities
        </mat-checkbox>

        <mat-checkbox formControlName="addESignature">
          Add eSignature
        </mat-checkbox>

        <mat-checkbox formControlName="addReasons"> Add Reasons </mat-checkbox>

        <mat-checkbox formControlName="addFieldPrompts">
          Add Field Prompts
        </mat-checkbox>

        <mat-checkbox formControlName="addParticipants">
          Add Participants
        </mat-checkbox>
      </div>
    </div> -->

      <!-- SHORT CIRCUIT OPTIONS -->
      <!-- <div class="col-12 mt-4">
      <p class="fw-semibold">Short-circuit tasks with the configured tags.</p>

      <div class="d-flex flex-wrap gap-3">
        <mat-checkbox formControlName="addComments">
          Add Comments
        </mat-checkbox>

        <mat-checkbox formControlName="addCapacities">
          Add Capacities
        </mat-checkbox>

        <mat-checkbox formControlName="addESignature">
          Add eSignature
        </mat-checkbox>

        <mat-checkbox formControlName="addReasons"> Add Reasons </mat-checkbox>

        <mat-checkbox formControlName="addFieldPrompts">
          Add Field Prompts
        </mat-checkbox>

        <mat-checkbox formControlName="addParticipants">
          Add Participants
        </mat-checkbox>
      </div>
    </div> -->
    </div>
  </form>
</div>
